define('bizzabo/app',[
    'jquery',
    'handlebars/helpers',
    'underscore',
    'backbone',
    'bizzabo/config',
    'bizzabo/bzapi',
    'bizzabo/consts',
    'bizzabo/ModelPool',
    'bizzabo/Analytics',
    'bizzabo/TotangoAnalytics',
    'bizzabo/routers/AppRouter',
    'bizzabo/models/Global',
    'bizzabo/views/AppView',
    'bizzabo/models/MultiAdmin'
], function(
    $,
    HandleBarsHelpers,
    _,
    Backbone,
    CONFIG,
    BZAPI,
    Consts,
    ModelPool,
    Analytics,
    TotangoAnalytics,
    AppRouter,
    Global,
    AppView,
    MultiAdmin
    ) {

    return (function() {
        // members

        var appView;
        var analytics;
        var modelPool;
        var appRouter;

        // Public methods

        var start = function() {
            // Set up the model pool
            modelPool = new ModelPool();
            Global.modelPool = modelPool;

            // Set up analytics
            analytics = new Analytics();
            Global.analytics = analytics;

            var activeEventSwitched = function(options) {
                var success = function(accountData) {
                    if (!CONFIG.ENABLE_TOTANGO) {
                        return;
                    }

                    var account = new Backbone.Model(accountData);
                    new TotangoAnalytics({
                        event: options.newActiveEvent,
                        account: account,
                        me: Global.modelPool.getMe()
                    });
                };

                var error = function(errorCode) {
                    var MissingOrExpiredSubscriptionError = 8001;
                    if (errorCode === MissingOrExpiredSubscriptionError) {
                        window.location = 'http://welcome.bizzabo.com/new-experience';
                    }
                };

                var accountId = options.newActiveEvent.get('account-id');
                BZAPI.getAccount(accountId, success, error);
            };

            var startApp = function() {
                Backbone.on(Consts.Notifications.activeEvent.SWITCHED, activeEventSwitched);

                // Set up the main view
                appView = new AppView({
                    el : $('body')
                });
                Global.appView = appView;

                // Set up the router
                appRouter = new AppRouter({
                    delegate : appView
                });

                //Set up multi admin handler
                Global.multiAdmin = new MultiAdmin({
                    appRouter : appRouter
                });

                Backbone.history.start();
            };

            // Start the router if the user is logged in, otherwise let him login
            if (!isAuthorized()) {
                return login();
            }

            modelPool.getMe().fetch({
                success: startApp,
                error: login
            });
        };

        var login = function() {
            return window.location = '/login?next=' + encodeURIComponent(window.location);
        };

        var getModelPool = function() {
            return modelPool;
        };

        var getAppView = function() {
            return appView;
        };

        var getAnalytics = function() {
            return analytics;
        };

        var isAuthorized = function() {
            if (modelPool && modelPool.getAuth()) {
                return modelPool.getAuth().get("isAuthorized");
            }
            return false;
        };

        Backbone.on('loginRequest', login, this);

        // Public object

        return {
            // Methods
            start : start,
            login : login,
            getModelPool : getModelPool,
            getAppView : getAppView,
            getAnalytics : getAnalytics,
            isAuthorized : isAuthorized
        };
    })();
});

